/* eslint no-console: 0 */
const MODE = {
  production: "warn",
  development: "debug",
};

const LEVEL = {
  undefined: 0,
  none: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4,
};

const OPT = process.env.NODE_ENV;

export default {
  install(Vue, options) {
    function vuelog(type, text) {
      console.log(`${type} ${text}`);
    }

    function vuedir(obj, text) {
      console.log(`DUMP ${text}`);
      console.dir(obj);
    }

    Vue.prototype.$log = {
      error(logs) {
        if (LEVEL["error"] <= LEVEL[MODE[options]]) {
          vuelog("ERROR", logs);
        }
      },
      warn(logs) {
        if (LEVEL["warn"] <= LEVEL[MODE[options]]) {
          vuelog("WARN ", logs);
        }
      },
      info(logs) {
        if (LEVEL["info"] <= LEVEL[MODE[options]]) {
          vuelog("INFO ", logs);
        }
      },
      debug(logs) {
        if (LEVEL["debug"] <= LEVEL[MODE[options]]) {
          vuelog("DEBUG", logs);
        }
      },
      dir(obj, logs) {
        if (logs == null) {
          logs = "[DUMP]Object";
        }
        if (LEVEL["debug"] <= LEVEL[MODE[options]]) {
          vuedir(obj, logs);
        }
      },
    };
  },
  error,
  warn,
  info,
  debug,
  dir,
};

function error(logs) {
  if (LEVEL["error"] <= LEVEL[MODE[OPT]]) {
    console.error("ERROR " + logs);
  }
}

function warn(logs) {
  if (LEVEL["warn"] <= LEVEL[MODE[OPT]]) {
    console.warn("WARN " + logs);
  }
}

function info(logs) {
  if (LEVEL["info"] <= LEVEL[MODE[OPT]]) {
    console.info("INFO " + logs);
  }
}

function debug(logs) {
  if (LEVEL["debug"] <= LEVEL[MODE[OPT]]) {
    console.log("DEBUG " + logs);
  }
}

function dir(obj, logs) {
  if (LEVEL["debug"] <= LEVEL[MODE[OPT]]) {
    if (logs == null) {
      logs = "[DUMP]Object";
    }
    console.log("DUMP " + logs);
    console.dir(obj);
  }
}
